/*
  Persistent first-party visitor id (Fit Finder A/B test).

  Recognizes the same visitor across sessions/days so on-site funnel events
  and an eventual Amazon purchase can be tied to one another via session_id.
  Stored in localStorage (not sessionStorage) so it survives across visits;
  expires after 90 days (matching Meta's fbp cookie convention), at which
  point a fresh id is generated. Respects the existing on-site analytics
  consent toggle. Loaded only on pages that are part of the Fit Finder A/B
  test (see device-compatibility.liquid's page_variant setting).
*/
(function () {
  'use strict';

  function getVisitorId() {
    try {
      var consent = window.Shopify && window.Shopify.customerPrivacy && window.Shopify.customerPrivacy.currentVisitorConsent
        ? window.Shopify.customerPrivacy.currentVisitorConsent()
        : null;
      if (consent && consent.analytics !== 'yes') return null; // respect existing consent choice

      var KEY = 'dongar_vid', TS_KEY = 'dongar_vid_ts', MAX_AGE_MS = 90 * 24 * 60 * 60 * 1000;
      var now = Date.now();
      var storedTs = parseInt(localStorage.getItem(TS_KEY) || '0', 10);
      var id = localStorage.getItem(KEY);
      if (!id || !storedTs || (now - storedTs) > MAX_AGE_MS) {
        if (!(window.crypto && window.crypto.randomUUID)) return null;
        id = window.crypto.randomUUID();
        localStorage.setItem(KEY, id);
        localStorage.setItem(TS_KEY, String(now));
      }
      return id;
    } catch (e) {
      return null; // storage blocked/unavailable — degrade gracefully, don't break the page
    }
  }

  window.dongarGetVisitorId = getVisitorId;
})();
